export type GuidedTour = {
  id: string;
  sections: string[];
};

export const OA_ADMIN_AREA: GuidedTour = {
  id: 'guided-tour-oa-admin-area',
  sections: ['generalInfo', 'myOrganization', 'myEmployees', 'myServices', 'myGroups'],
};
